import React from 'react'
import PatientsCollections from 'features/surgical-cloud/PatientsCollections'

const SurgicalCloud = () => {
    return <PatientsCollections />
}

export default SurgicalCloud
